<template>
  <div class="supplier-page">
    <div class="page-header-bar">
      <div class="page-header-title">
        <h2>数据抽查</h2>
      </div>
      <div class="page-header-tool">
        <el-button type="primary" size="mini" @click="rechargedialog = true; dialogtype = 0">新增抽查任务</el-button>
      </div>
    </div>
    <div class="tablebox">
      <el-table :data="mergedData" size="mini">
        <el-table-column label="ID" prop="id" width="80"></el-table-column>
        <el-table-column label="taskId" prop="taskId" width="80"></el-table-column>
        <el-table-column label="订阅名称" prop="subscriptionName" width="200"></el-table-column>
        <el-table-column label="抽查百分比" prop="percentage"></el-table-column>
        <el-table-column label="抽查数量" prop="quantity"></el-table-column>
        <el-table-column label="预计报告时间" prop="reportTime" width="150"></el-table-column>
        <el-table-column label="状态" prop="spotstatusstr"></el-table-column>
        <el-table-column label="操作" prop="status" width="400">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.status != 0" :loading="scope.row.loadingbtn" type="primary" @click="statCheck(scope.row)" size="mini">立即运行</el-button>
            <el-button :disabled="scope.row.status != 2" type="success" @click="downloadreport(scope.row)" size="mini">下载报告</el-button>
            <el-button type="warning" @click="editDialog(scope.row)" size="mini">编辑</el-button>
            <el-popconfirm title="确定删除吗？" @confirm="delCheck(scope.row)">
              <el-button type="danger" slot="reference" size="mini">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      title="添加抽查任务"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="rechargedialog"
      width="400px"
      center
    >
      <div class="edit-form">
        <el-form :model="spotform" ref="addnewsupplierdialog" label-width="100px" size="mini">
          <el-form-item label="订阅名称">
            <el-col :span="18">
              <el-select 
                style="width:100%;" 
                v-model="spotform.taskId" 
                filterable placeholder="请选择订阅"
                @change="changebrand(spotform.taskId)"
              >
                <el-option
                  v-for="item in subnamelist"
                  :key="item.taskId"
                  :label="item.subscriptionName"
                  :value="item.taskId">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="抽查百分比">
            <el-col :span="18">
              <el-select 
                style="width:100%;" 
                v-model="spotform.percentage" 
                filterable placeholder="请选择比例"
                @change="changepercent()"
              >
                <el-option
                  v-for="item in spotpercent"
                  :key="item"
                  :label="item + '%'"
                  :value="item + '%'">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="抽查数量">
            <el-col :span="18">
              <el-input v-model="spotform.quantity" @input="changequantity()"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="预计报告时间">
            <el-col :span="18">
              <el-input v-model="spotform.reportTime"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelRechargeDialog()" size="small">取 消</el-button>
        <el-button v-if="dialogtype == 0" type="primary" @click="confirmRecharge()" size="small" :loading="loadingbtndialog">确 定</el-button>
        <el-button v-if="dialogtype == 1" type="primary" @click="editCheck()" size="small" :loading="loadingbtndialog">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data(){
    const _percent = [];
    for (let i = 5; i < 100; i += 5) {
      _percent.push(i);
    }
    return{
      rechargedialog: false,
      spotform: {
        taskId: '',
        percentage: '',
        quantity: '',
        reportTime: ''
      },
      spotlist: [],
      subnamelist: [],
      accountlist: [],
      spotpercent: _percent,
      selectbrand: {},
      mergedData: [],
      loadingbtndialog: false,
      dialogtype: 0
    }
  },

  mounted(){
    this.findaccountList()
    this.fetchData()
  },

  methods: {
    /**
     * 取消弹窗
     */
    cancelRechargeDialog: function(){
      this.rechargedialog = false
      this.spotform = {
        name: '',
        percent: '',
        num: ''
      }
    },

    /**
     * 获取数据
     */
    fetchData() {
      let that = this
      $.when(
        $.ajax({ url: '//similarpic.simplybrand.com/api/samplingtask/findsamplingTask', method: 'GET' }),
        $.ajax({ url: '//similarpic.simplybrand.com/api/samplingtask/findsubscription', method: 'GET' })
      ).done(function (resA, resB) {
        var dataA = resA[0].data;
        var dataB = resB[0].data;
        that.subnamelist = dataB
        
        var mapB = {};
        dataB.forEach(function(item) {
          mapB[item.taskId] = item;
        });

        // 合并数据
        var merged = dataA.map(function(itemA) {
          return {
            ...itemA,
            ...(mapB[itemA.taskId] || {})
          };
        });
        merged.forEach(item => {
          item.reportTime = that.$moment(item.reportTime).utc().format('MM/DD HH:mm')
          item.spotstatusstr = item.status == 0 ? '待执行' : item.status == 1 ? '执行中' : item.status == 2 ? '已完成' : ''
          item.loadingbtn = false
        })
        that.mergedData = merged
      });
    },

    /**
     * 账号信息
     */
    findaccountList: function(){
      let that = this
      let url = '//similarpic.simplybrand.com/api/samplingtask/findaccountList'
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          that.accountlist = data.data
        },
        error: function(response) {
          console.log('findaccountList', response)
        }
      })
    },

    /**
     * 选择品牌
     */
    changebrand: function(brand){
      this.selectbrand = this.subnamelist.find(subitem => subitem.taskId === brand);
    },

    /**
     * 选择抽查百分比
     */
    changepercent: function(){
      let _count = this.selectbrand.Count
      let _numpercent = parseFloat(this.spotform.percentage.replace('%', ''))
      this.spotform.quantity = Math.round(_count * (_numpercent / 100))
      this.changequantity()
    },

    /**
     * change
     */
    changequantity: function(){
      const totalRate = this.accountlist.reduce((sum, account) => sum + (1 / account.Frequency), 0)
      const totaltimes = this.spotform.quantity / totalRate
      const currentDate = new Date(); //当前时间
      const futureDate = new Date(currentDate.getTime() + totaltimes * 60000); //未来时间
      const formatfutureDate = this.$moment(futureDate).format('YYYY-MM-DD HH:mm')
      this.spotform.reportTime = formatfutureDate
    },

    /**
     * 添加抽查任务
     */
    confirmRecharge: function(){
      let that = this
      let api_url = '//similarpic.simplybrand.com/api/samplingtask/addsamplingTask'
      that.loadingbtndialog = true
      $.ajax({
        url: api_url,
        type: "POST",
        changeOrigin: true,
        crossDomain: true,
        data: that.spotform,
        success: function(data) {
          console.log('editCheck', data)
          setTimeout(() => {
            that.fetchData()
            that.$message({
              message: '添加抽查任务成功',
              type: 'success'
            });
            that.cancelRechargeDialog()
            that.loadingbtndialog = false
          }, 3000)
        },
        error: function(response) {
          console.log('confirmAddSupplier', response)
        }
      })
    },

    /**
     * 立即运行
     */
    statCheck: function(task){
      let that = this
      let api_url = '//similarpic.simplybrand.com/api/samplingtask/addmonitorList'
      let _query = {
        taskId: task.taskId,
        quantity: task.quantity,
        id: task.id
      }
      task.loadingbtn = true
      $.ajax({
        url: api_url,
        type: "POST",
        changeOrigin: true,
        crossDomain: true,
        data: _query,
        success: function(data) {
          console.log('statCheck', data)
          setTimeout(() => {
            that.fetchData()
            that.$message({
              message: '任务已启动',
              type: 'success'
            });
          }, 3000)
        },
        error: function(response) {
          console.log('statCheck', response)
        }
      })
    },

    /**
     * 编辑弹窗
     */
    editDialog: function(obj){
      this.dialogtype = 1
      this.rechargedialog = true
      this.selectbrand = this.subnamelist.find(subitem => subitem.taskId === obj.taskId);
      this.spotform.taskId = obj.taskId
      this.spotform.percentage = obj.percentage
      this.spotform.quantity = obj.quantity
      this.editspotid = obj.id
      this.changequantity()
    },
    
    /**
     * 编辑
     */
    editCheck: function(){
      let that = this
      let api_url = '//similarpic.simplybrand.com/api/samplingtask/updatesamplingTask'
      that.loadingbtndialog = true
      let _query = {
        taskId: this.spotform.taskId,
        percentage: this.spotform.percentage,
        quantity: this.spotform.quantity,
        reportTime: that.$moment(this.spotform.reportTime).format('YYYY-MM-DD HH:mm:ss'),
        id: this.editspotid,
        status: 0
      }
      $.ajax({
        url: api_url,
        type: "POST",
        changeOrigin: true,
        crossDomain: true,
        data: _query,
        success: function(data) {
          console.log('editCheck', data)
          setTimeout(() => {
            that.fetchData()
            that.$message({
              message: '任务已修改',
              type: 'success'
            });
            that.cancelRechargeDialog()
            that.loadingbtndialog = false
          }, 3000)
        },
        error: function(response) {
          console.log('statCheck', response)
        }
      })
    },

    /**
     * 删除
     */
    delCheck: function(obj){
      let that = this
      let api_url = '//similarpic.simplybrand.com/api/samplingtask/updatesamplingTask'
      let _query = {
        taskId: obj.taskId,
        percentage: obj.percentage,
        quantity: obj.quantity,
        reportTime: that.$moment(obj.reportTime).format('YYYY-MM-DD HH:mm:ss'),
        id: obj.id,
        status:3
      }
      $.ajax({
        url: api_url,
        type: "POST",
        changeOrigin: true,
        crossDomain: true,
        data: _query,
        success: function(data) {
          console.log('statCheck', data)
          that.$message({
            message: '任务已删除',
            type: 'success'
          });
          setTimeout(that.fetchData(), 5000)
        },
        error: function(response) {
          console.log('statCheck', response)
        }
      })
    },
    
    /**
     * 下载报告
     */
    downloadreport: function(obj){
      let that = this
      let filenametime = that.$moment(new Date(),'YYYY-MM-DDTHH:mm:ss.SSS').format('YYYYMMDDHHmm')
      let url = '//similarpic.simplybrand.com/api/samplingtask/findsamplingResult' + '?taskId=' + obj.taskId
      let filename = obj.subscriptionName
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      // xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            var a = document.createElement('a')
            a.download = filename + '_数据抽查报告_' + filenametime+'.xlsx'
            a.href = e.target.result
            $("body").append(a)
            a.click()
            $(a).remove()
            that.downloading = false
          }
        }
      }
      xhr.send()
    },
  }
}
</script>